export default __webpack_public_path__ + "static/media/Blade of the Crowned Serpent.c7ff38fb.jpg";